import { match, generateRandomString } from '@/Helpers/methods'

export default class BlockId {
    static getCategory(type) {
        const category = match(type, {
            name: 'name',
            email: 'email',
            'file-upload': 'file',
            hidden: 'hidden',

            number: 'number',
            percent: 'number',
            currency: 'number',

            phone: 'text',
            'phone-v2': 'text',
            url: 'text',
            text: 'text',
            textarea: 'text',

            checkboxes: 'select',
            radios: 'select',
            'select-one-image': 'select',
            dropdown: 'select',
            confirm: 'select',
            scale: 'select',

            h1: 'content',
            h2: 'content',
            paragraph: 'content',
            'rich-text': 'content',
            image: 'content',
            embed: 'content',
            'calendly-embed': 'content',
            'hubspot-calendar-embed': 'content',
        })

        if (!category) {
            throw new Error('Unkown block type')
        }

        return category
    }

    static generate(type) {
        const category = BlockId.getCategory(type)
        const randomString = generateRandomString(10)

        return `blk_${category}_${randomString}`
    }
}
